import { render, staticRenderFns } from "./MobileCollapse.vue?vue&type=template&id=5004e32c&scoped=true&"
import script from "./MobileCollapse.vue?vue&type=script&lang=js&"
export * from "./MobileCollapse.vue?vue&type=script&lang=js&"
import style0 from "./MobileCollapse.vue?vue&type=style&index=0&id=5004e32c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5004e32c",
  null
  
)

export default component.exports